import { SHIPPING_MODEL_KEY } from 'models/daos/shipping/constants'
import { getUserAddressSelector } from 'modules/address/selectors'
import { getSubTotalWithDiscountsCartSelector } from 'modules/cart/selectors/get-sub-total-with-discount'
import { getTaxCartUtil } from 'modules/cart/utils'
import { getValueCurrencySelector } from 'modules/currencies/selectors'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { SHIPPING_DEFAULT_INTERNATIONAL_RATE_PRICE } from 'modules/shipping/constants'
import { getSelectedMethodShippingSelector } from 'modules/shipping/selectors/get-selected-method'
import { createSelector } from 'reselect'

function getTotalPriceCartSelector () {
  return createSelector(getSelectedMethodShippingSelector(),
    getSubTotalWithDiscountsCartSelector(),
    getValueCurrencySelector(),
    getUserAddressSelector(),
    (state, props) => props?.shouldExcludeShipping,
    (selectedShippingService,
      subTotalWithDiscounts,
      currencyValue,
      address,
      shouldExcludeShipping
    ) => {
      let shippingRate
      if (selectedShippingService && !getValueReduxUtil(selectedShippingService,
        SHIPPING_MODEL_KEY.LOCAL_IS_FREE
      )) {
        shippingRate = selectedShippingService.data.price
      } else if (getValueReduxUtil(selectedShippingService,
        SHIPPING_MODEL_KEY.LOCAL_IS_FREE
      )) {
        shippingRate = 0
      } else {
        shippingRate = SHIPPING_DEFAULT_INTERNATIONAL_RATE_PRICE
      }

      const tax = getTaxCartUtil(subTotalWithDiscounts, address)
      const total = subTotalWithDiscounts + tax
      if (shouldExcludeShipping) {
        return total
      }
      return total + (
        shippingRate * currencyValue
      )
    }
  )
}

export {
  getTotalPriceCartSelector
}
